import { api } from "../api";

export type DeletionReason =
  | "notUsing"
  | "justTesting"
  | "competitor"
  | "hardToUse"
  | "missingFeature"
  | "technical"
  | "privacy"
  | "duplicate"
  | "other";

/** The step the user reached: saved at every step, so leaving mid-way is data too. */
export type DeletionStep = "reason" | "detail" | "confirm" | "deleted";

export type AccountDeletionSurvey = {
  /** One per run of the flow (a new one each time the user starts it). */
  surveyId: string;
  step: DeletionStep;
  reason?: DeletionReason;
  /** Free text for "other". */
  reasonText?: string;
  detail?: { options?: string[]; text?: string };
  /** What the app already knows; the backend adds when the account was created. */
  context: {
    keeposCount: number;
    hadPlus: boolean;
    locale: string;
  };
};

export const accountDeletionService = {
  async saveProgress(survey: AccountDeletionSurvey): Promise<void> {
    await api.saveAccountDeletionSurvey(survey);
  },

  async deleteAccount(): Promise<void> {
    await api.deleteAccount();
  },
};
